var ajax = require('./sv-jedesheim.ajax.js');
var utils = require('./sv-jedesheim.utils.js');

function registerCommonEvents() {

	setParallaxHeight();

	$('.nav[role="tablist"] a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
		window.location.hash = e.target.hash.replace('tab_', '');

		if ($('.c-mosaic').length) {
			$('.c-mosaic').cubeportfolio('destroy');
			$('.c-mosaic').cubeportfolio({
				layoutMode: 'mosaic'
			});
		}

		setParallaxHeight();

		return false;
	});

	$(document).on("shown.bs.collapse", ".js-tabcollapse-panel", function (e) {
		if ($(e.target).hasClass('js-tabcollapse-panel')) {
			window.location.hash = e.target.id.replace('tab_', '').replace('-collapse', '');

			if ($('.c-mosaic').length) {
				$('.c-mosaic').cubeportfolio('destroy');
				$('.c-mosaic').cubeportfolio({
					layoutMode: 'mosaic'
				});
			}

			var element = $(e.target);
			$("html, body").animate({
				scrollTop: element.offset().top - 65 - 47
			}, 600);
		}
	});

	$('body').on('click', '.c-select-xls-file', function (e) {
		e.preventDefault();

		$(this).parent().find('[name="file_upload"]').click();
	});

	$('body').on('click', '.c-pagination li', function (e) {
		e.preventDefault();

		var element = $(this).parents('.c-content-box');
		$("html, body").animate({
			scrollTop: element.offset().top - 65 - 47
		}, 600);
	});

	$('body').on('change', '[name="file_upload"]', function (e) {

		if ($(this).parent().find('#date_table,#record_table').length) {
			var ext = $(this)[0].files[0].name.split('.').pop().toLowerCase();

			if ($.inArray(ext, ['xls','xlsx','csv']) == -1) {

				$('<div class="alert alert-danger alert-dismissible margin-top-10" role="alert">' + trans('sv-jedesheim.wrong_file_type', {file_types: '.xls,.xlsx,.csv'}) + '<br><br>' + $(this)[0].files[0].name +
					'<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
					'<span aria-hidden="true">×</span>' +
					'</button>' +
					'</div>').insertAfter($(this).parents('.form-group').find('.c-select-xls-file'));
			} else {
				$(this).parent().find('#date_table,#record_table').val($(this)[0].files[0].name);
			}
		} else {
			$(this).parent().find('#document').val($(this)[0].files[0].name);
		}
	});


	$('body').on('click', '.c-select-file,.c-select-files', function (e) {
		e.preventDefault();

		var count = $(this).parent().find('.c-preview .c-container').find('.c-file-upload').length;
		if ($(this).hasClass('c-select-files')) {
			$(this).parent().find('.c-preview .c-container').append('<input name="file_upload_' + (count + 1) + '[]" class="hide c-files-upload" type="file" multiple>');
		} else {
			$(this).parent().find('.c-preview .c-container').append('<input name="file_upload_' + (count + 1) + '[]" class="hide c-file-upload" type="file">');
		}

		$(this).parent().find('.c-preview .c-container').find('.c-file-upload:last,.c-files-upload:last')[0].click();
	});

	$('body').on('change', '.c-files-upload,.c-file-upload', function (e) {
		var fileUpload = this;
		var fileTooLarge = '';
		var wrongFileType = '';
		$.each($(this)[0].files, function(i, file) {
			var ext = file.name.split('.').pop().toLowerCase();
			if (file.size > 2097152) {
				if (fileTooLarge !== '') {
					fileTooLarge += '<br>';
				}
				fileTooLarge += file.name;
			} else if ($.inArray(ext, ['png','jpg','jpeg']) == -1) {
				if (wrongFileType !== '') {
					wrongFileType += '<br>';
				}
				wrongFileType += file.name;
			} else {
				if ($(fileUpload).hasClass('c-file-upload')) {
					$(fileUpload).parent().find('.c-works').find('li').remove();
				}
				var count = $(fileUpload).parent().find('.c-works').find('li').length;
				$(fileUpload).parent().find('.c-works').append(
					'<li class="c-content-isotope-item">' +
					'<div class="c-content-isotope-image-container">' +
					'<input type="hidden" value="' + file.name + '" name="img_' + (count + 1) + '">' +
					'<img id="img_' + (count + 1) + '" src="" alt="" class="img-responsive c-content-isotope-image">' +
					'<div class="c-content-isotope-overlay">' +
					'<div class="c-content-isotope-overlay-content">' +
					'<a href="javascript:;" class="c-content-isotope-overlay btn c-btn-red c-btn-uppercase c-btn-bold c-btn-border-1x c-btn-square c-delete-preview-image">' + trans('sv-jedesheim.delete') + '</a>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'</li>'
				);
				var reader = new FileReader();
				reader.onload = function (e) {
					$('#img_' + (count + 1)).attr('src', e.target.result);
				}
				reader.readAsDataURL(file);
			}
		});
		if (fileTooLarge !== '' || wrongFileType !== '') {

			var text = '';
			if (fileTooLarge !== '' && wrongFileType !== '') {
				text = trans('sv-jedesheim.files_too_large') + '<br>' + fileTooLarge + '<br><br>' + trans('sv-jedesheim.wrong_file_type', {file_types: '.png,.jpg,.jpeg'}) + '<br>' + wrongFileType;
			} else if (fileTooLarge !== '') {
				text = trans('sv-jedesheim.files_too_large') + '<br>' + fileTooLarge;
			} else if (wrongFileType !== '') {
				text = trans('sv-jedesheim.wrong_file_type', {file_types: '.png,.jpg,.jpeg'}) + '<br>' + wrongFileType;
			}
			$('<div class="alert alert-danger alert-dismissible margin-top-10" role="alert">' + text +
				'<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
				'<span aria-hidden="true">×</span>' +
				'</button>' +
				'</div>').insertAfter($(this).parents('.form-group').find('.c-select-file,.c-select-files'));
		}
	});

	$('body').on('click', '.c-delete-preview-image', function(e) {
		e.preventDefault();

		$(this).parents('li').remove();
	});

	$('body').on('click', '.c-save', function (e) {
		e.preventDefault();

		$(this).parents('form').submit();
	});

	$('body').on('click', '.c-delete', function (e) {
		e.preventDefault();

		var data = '';
		if ($(this).parents('.tab-pane').length)
		{
			data = 'section_link=' + $(this).parents('.tab-pane').data().tabLink;
		}
		if ($(this).find('[name="sub_section"]').val() !== '')
		{
			data = '&sub_section=' + $(this).find('[name="sub_section"]').val();
		}

		ajax.ajaxCall($(this).data().href, 'DELETE', data, function (data) {

			if (document.location.href === data['intended']) {
				location.reload();
			} else {
				document.location.href = data['intended'];
			}
		});
	});

	// Dialog schließen
	$('body').on('hide.bs.modal', '.modal', function (e) {
		if (!utils.isUndefined($(this).find('form')[0])) {

			utils.resetForm(this);
			if ($(this)[0].id == 'add_member_dialog') {
				$('#add_member_dialog').find('[name=member_icon]').removeAttr('checked');
				$('#add_member_dialog').find('[name=member_icon][value=icon-user]').attr('checked', 'checked');
			}
		}
	});

	$('body').on('click', '.c-add-entry', function (e) {
		e.preventDefault();

		if ($(this).data().target == '#add_training_dialog') {
			$('#add_training_dialog').find('[name=section_link]').val($(this).parents('.tab-pane').data().tabLink);
		} else if ($(this).data().target == '#add_gymnastic_dialog') {
			$('#add_gymnastic_dialog').find('[name=section_link]').val($(this).parents('.tab-pane').data().tabLink);
		} else if ($(this).data().target == '#add_team_dialog') {
			$('#add_team_dialog').find('[name=section_link]').val($(this).parents('.tab-pane').data().tabLink);
		}
	});

	$('body').on('click', '.c-edit-entry', function (e) {
		e.preventDefault();

		var object = $(this).data().object;

		if ($(this).data().target == '#add_date_dialog') {
			$('#add_date_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_date_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_date_dialog').find('[name=date_title]').val(object.title);
			$('#add_date_dialog').find('[name=date_link]').val(object.link);
			$('#add_date_dialog').find('[name=date_link_description]').val(object.link_description);
			$('#add_date_dialog').find('[name=date_position]').val(object.position);
			$('#add_date_dialog').find('[name=date_table]').val(object.document_name);
			$('#add_date_dialog').find('form').attr('action', $('#add_date_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_date_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');
		} else if ($(this).data().target == '#add_team_dialog') {
			$('#add_team_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_team_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_team_dialog').find('[name=section_link]').val($(this).parents('.tab-pane').data().tabLink);
			$('#add_team_dialog').find('[name=team_name]').val(object.team_name);
			$('#add_team_dialog').find('[name=team_division]').val(object.division);
			$('#add_team_dialog').find('[name=team_description]').val(object.description.replace(/<br ?\/?>/g, ""));
			$('#add_team_dialog').find('[name=team_position]').val(object.position);
			$('#add_team_dialog').find('[name=team_link]').val(object.link);
			$('#add_team_dialog').find('[name=team_link_description]').val(object.link_description);
			$('#add_team_dialog').find('[name=team_link_alternative]').val(object.link_alternative);
			$('#add_team_dialog').find('[name=team_link_alternative_description]').val(object.link_alternative_description);
			$('#add_team_dialog').find('form').attr('action', $('#add_team_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_team_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');

			if (object.image_path !== '') {
				$('#add_team_dialog').find('.c-works').append(
					'<li class="c-content-isotope-item">' +
					'<div class="c-content-isotope-image-container">' +
					'<input type="hidden" value="' + object.image_path.substring(object.image_path.lastIndexOf("/") + 1, object.image_path.length) + '" name="img_1">' +
					'<img id="img_1" src="' + object.image_path + '" alt="" class="img-responsive c-content-isotope-image">' +
					'<div class="c-content-isotope-overlay">' +
					'<div class="c-content-isotope-overlay-content">' +
					'<a href="javascript:;" class="c-content-isotope-overlay btn c-btn-red c-btn-uppercase c-btn-bold c-btn-border-1x c-btn-square c-delete-preview-image">' + trans('sv-jedesheim.delete') + '</a>' +
					'</div>' +
					'</div>' +
					'</div>' +
					'</li>'
				);
			}
		} else if ($(this).data().target == '#add_news_entry_dialog') {
			$('#add_news_entry_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_news_entry_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_news_entry_dialog').find('[name=news_date]').data('picker').setDate(utils.stringToDate(object.news_date));
			$('#add_news_entry_dialog').find('[name=news_title]').val(object.title);
			$('#add_news_entry_dialog').find('[name=news_description]').val(object.description.replace(/<br ?\/?>/g, ""));
			var tagArray = [];
			$.each(object.news_tags, function (i, tag) {
				tagArray.push(tag.tag.toUpperCase());
			});
			$('#add_news_entry_dialog').find('[name=news_tags]').select2().val(tagArray).trigger('change');
			$('#add_news_entry_dialog').find('form').attr('action', $('#add_news_entry_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_news_entry_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');

			if (object.news_images.length > 0) {
				var count = 1;
				$.each(object.news_images, function (i, image) {
					$('#add_news_entry_dialog').find('.c-works').append(
						'<li class="c-content-isotope-item">' +
						'<div class="c-content-isotope-image-container">' +
						'<input type="hidden" value="' + image.path + '" name="existing_img_' + count + '">' +
						'<img id="existing_img_' + count + '" src="' + image.path + '" alt="" class="img-responsive c-content-isotope-image">' +
						'<div class="c-content-isotope-overlay">' +
						'<div class="c-content-isotope-overlay-content">' +
						'<a href="javascript:;" class="c-content-isotope-overlay btn c-btn-red c-btn-uppercase c-btn-bold c-btn-border-1x c-btn-square c-delete-preview-image">' + trans('sv-jedesheim.delete') + '</a>' +
						'</div>' +
						'</div>' +
						'</div>' +
						'</li>'
					);
					count += 1;
				});
			}
		} else if ($(this).data().target == '#add_record_dialog') {
			$('#add_record_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_record_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_record_dialog').find('[name=record_title]').val(object.title);
			$('#add_record_dialog').find('[name=record_position]').val(object.position);
			$('#add_record_dialog').find('[name=record_table]').val(object.document_name);
			$('#add_record_dialog').find('form').attr('action', $('#add_record_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_record_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');
		} else if ($(this).data().target == '#add_document_dialog') {
			$('#add_document_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_document_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_document_dialog').find('[name=document]').val(object.document);
			$('#add_document_dialog').find('[name=document_description]').val(object.document_description);
			$('#add_document_dialog').find('[name=link]').val(object.link);
			$('#add_document_dialog').find('[name=link_description]').val(object.link_description);
			$('#add_document_dialog').find('[name=position]').val(object.position);
			$('#add_document_dialog').find('form').attr('action', $('#add_document_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_document_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');
		} else if ($(this).data().target == '#add_training_dialog') {
			$('#add_training_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_training_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_training_dialog').find('[name=section_link]').val($(this).parents('.tab-pane').data().tabLink);
			$('#add_training_dialog').find('[name=training_day_and_time]').val(object.day_and_time.replace(/<br ?\/?>/g, ""));
			$('#add_training_dialog').find('[name=training_location1]').val(object.location1.replace(/<br ?\/?>/g, ""));
			$('#add_training_dialog').find('[name=training_location2]').val(object.location2);
			$('#add_training_dialog').find('[name=training_address]').val(object.address);
			$('#add_training_dialog').find('[name=training_position]').val(object.position);
			$('#add_training_dialog').find('form').attr('action', $('#add_training_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_training_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');
		} else if ($(this).data().target == '#add_gymnastic_dialog') {
			$('#add_gymnastic_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_gymnastic_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_gymnastic_dialog').find('[name=section_link]').val($(this).parents('.tab-pane').data().tabLink);
			$('#add_gymnastic_dialog').find('[name=gymnastic_day_and_time]').val(object.day_and_time.replace(/<br ?\/?>/g, ""));
			$('#add_gymnastic_dialog').find('[name=gymnastic_location1]').val(object.location1.replace(/<br ?\/?>/g, ""));
			$('#add_gymnastic_dialog').find('[name=gymnastic_location2]').val(object.location2);
			$('#add_gymnastic_dialog').find('[name=gymnastic_address]').val(object.address);
			$('#add_gymnastic_dialog').find('[name=gymnastic_position]').val(object.position);
			$('#add_gymnastic_dialog').find('form').attr('action', $('#add_gymnastic_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_gymnastic_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');
		} else if ($(this).data().target == '#add_member_dialog') {
			$('#add_member_dialog').find('.c-dialog-title-add').addClass('hide');
			$('#add_member_dialog').find('.c-dialog-title-edit').removeClass('hide');

			$('#add_member_dialog').find('[name=section_link]').val($(this).parents('.tab-pane').data().tabLink);
			$('#add_member_dialog').find('[name=member_name]').val(object.name);
			$('#add_member_dialog').find('[name=member_capacity]').val(object.capacity);
			$('#add_member_dialog').find('[name=member_icon]').removeAttr('checked');
			$('#add_member_dialog').find('[name=member_icon][value=' + object.icon + ']').attr('checked', 'checked');
			$('#add_member_dialog').find('[name=member_phone]').val(object.phone);
			$('#add_member_dialog').find('[name=member_email]').val(object.email);
			$('#add_member_dialog').find('[name=member_position]').val(object.position);
			$('#add_member_dialog').find('form').attr('action', $('#add_member_dialog').find('form').attr('action') + '/' + object.id);
			$('#add_member_dialog').find('form').prepend('<input type="hidden" name="_method" value="PUT">');
		} else if ($(this).data().target == '#edit_events_dialog') {
			$('#edit_events_dialog').find('[name=event_date]').data('picker').setDate(utils.stringToDate(object.date));
			$('#edit_events_dialog').find('[name=event_title]').val(object.title);
			$('#edit_events_dialog').find('[name=event_description]').val(object.desc);

			$('#edit_events_dialog').find('[name=document]').val(object.file_path);
			$('#edit_events_dialog').find('[name=document_description]').val(object.file_name);
			$('#edit_events_dialog').find('[name=link]').val(object.link);
			$('#edit_events_dialog').find('form').attr('action', $('#edit_events_dialog').find('form').attr('action') + '/' + object.id);
		}
	});
}

function setParallaxHeight() {
	var elements = $('.c-content-feature-4 .c-content-right.c-diagonal,.c-content-feature-4 .c-content-left.c-diagonal');

	if (elements.length) {
		$.each(elements, function(i, element) {
			$(element).css('border-top-width', $(element).parent().height());
		});

	}
}

module.exports.registerCommonEvents = registerCommonEvents;
